import Vue from "vue";

import ForgotPassword from "./ForgotPassword.vue";

export function load() {
    const selector = "forgot-password";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(ForgotPassword, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
